export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const auth = (token) => ({ headers: { Authorization: `Bearer ${token}` } });

export const LEAD_STATUSES = [
  ["new", "New", "bg-amber-100 text-amber-800 border-amber-300"],
  ["contacted", "Contacted", "bg-sky-100 text-sky-800 border-sky-300"],
  ["interested", "Interested", "bg-emerald-100 text-emerald-800 border-emerald-300"],
  ["sample_requested", "Sample Requested", "bg-teal-100 text-teal-800 border-teal-300"],
  ["quotation_sent", "Quotation Sent", "bg-yellow-100 text-yellow-800 border-yellow-300"],
  ["negotiation", "Negotiation", "bg-orange-100 text-orange-800 border-orange-300"],
  ["payment_pending", "Payment Pending", "bg-rose-100 text-rose-800 border-rose-300"],
  ["won", "Won", "bg-green-600 text-white border-green-600"],
  ["lost", "Lost", "bg-red-100 text-red-700 border-red-300"],
  ["no_response", "No Response", "bg-gray-100 text-gray-600 border-gray-300"],
];
export const statusMeta = (s) => LEAD_STATUSES.find(([k]) => k === s) || LEAD_STATUSES[0];

export const LEAD_SOURCES = [
  "Website", "Google Ads", "Instagram", "WhatsApp", "LinkedIn",
  "Trade Show", "Go4WorldBusiness", "Volza", "Freshdi", "Other",
];

export const PRODUCT_INTERESTS = [
  "Vanilla Planifolia Grade A",
  "Vanilla Tahitensis Grade A",
  "Grade C",
  "Vanilla Powder",
  "Multiple / Custom Mix",
];

export const ORDER_STATUSES = [
  ["payment_pending", "Payment Pending"],
  ["paid", "Paid"],
  ["shipped", "Shipped"],
  ["delivered", "Delivered"],
  ["cancelled", "Cancelled"],
];

export const QUOTE_STATUSES = [
  ["sent", "Sent"],
  ["accepted", "Accepted"],
  ["rejected", "Rejected"],
];

export const COMM_TYPES = [
  ["note", "Note"],
  ["whatsapp", "WhatsApp"],
  ["email", "Email"],
  ["call", "Call"],
];

export const today = () => new Date().toISOString().slice(0, 10);
export const isDue = (l) =>
  l.follow_up_date && !["won", "lost"].includes(l.status || "new") && l.follow_up_date <= today();
export const fmtMoney = (n, c = "USD") =>
  `${c} ${Number(n || 0).toLocaleString("en-US", { minimumFractionDigits: 2 })}`;

export const inputCls =
  "w-full bg-white border border-[#E6DEC3] rounded-xl px-3.5 py-2.5 text-sm text-[#2C1A0C] placeholder:text-[#6E5B4F]/50 focus:outline-none focus:ring-2 focus:ring-[#2E4F3E]/40 focus:border-[#2E4F3E] transition";

export const labelCls = "block font-mono text-[10px] tracking-[0.18em] uppercase text-[#5C3A21] mb-1.5";
